import React from "react";
import { sanitizeHtml } from "../../../../utils/sanitizeHtml";

/**
 * "Word of the Day" panel. Field names aren't confirmed against the real
 * backend contract yet, so every value is read defensively with a fallback.
 * The "Word of the Day" title itself is rendered by the Dashboard page as a
 * sibling heading (matching the "Upcoming Events" column) so both columns'
 * cards start at the same vertical offset.
 */
const WordOfTheDayCard = ({ wordOfTheDay }) => {
  if (!wordOfTheDay) {
    return (
      <div className="sp-card student-dashboard__wotd" data-tone="primary">
        <p className="text-muted mb-0">Nothing to show today.</p>
      </div>
    );
  }

  const word = wordOfTheDay?.word || wordOfTheDay?.title;
  const partOfSpeech = wordOfTheDay?.part_of_speech || wordOfTheDay?.type;
  const pronunciation = wordOfTheDay?.pronunciation || wordOfTheDay?.phonetic;
  const meaning = wordOfTheDay?.meaning || wordOfTheDay?.description || wordOfTheDay?.definition;
  const example = wordOfTheDay?.example || wordOfTheDay?.example_sentence || wordOfTheDay?.usage;

  return (
    <div className="sp-card student-dashboard__wotd" data-tone="primary">
      <p className="student-dashboard__wotd-word">{word || "—"}</p>
      {(partOfSpeech || pronunciation) && (
        <p className="student-dashboard__wotd-sub">
          {partOfSpeech}
          {partOfSpeech && pronunciation ? " | " : ""}
          {pronunciation}
        </p>
      )}

      {/* Confirmed against the real backend (2026-10-22): rich-text fields
          on this backend (FAQ description, circular_desc, event
          description) all come back as HTML ("<p>...</p>"), not plain
          text — rendered as HTML here too instead of showing raw tags. */}
      {meaning && (
        <>
          <p className="student-dashboard__wotd-label">Meaning</p>
          {/* eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above */}
          <div className="student-dashboard__wotd-text" dangerouslySetInnerHTML={{ __html: sanitizeHtml(meaning) }} />
        </>
      )}

      {example && (
        <>
          <p className="student-dashboard__wotd-label">Example</p>
          <div
            className="student-dashboard__wotd-example"
            // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(example) }}
          />
        </>
      )}
    </div>
  );
};

export default WordOfTheDayCard;
